import { Box, ClickAwayListener, SxProps, Theme, Typography, Popper } from '@mui/material';
import { FC } from 'react';
import { RoundedPaper } from '../../../../lib/components';
import { OverlayViewModel } from '../../../../hooks/useOverlay';
import { observer } from 'mobx-react-lite';
import { ReceiptsViewModel } from '../../../../viewModels/receipts';

export interface ReceiptsNoteOverlayProps {
  viewModel: OverlayViewModel<ReceiptsViewModel>;
  sx?: SxProps<Theme>;
}

export const NoteOverlay: FC<ReceiptsNoteOverlayProps> = observer(({ viewModel, sx }) => {
  const renderContent = (content?: string) => {
    return (
      <Typography variant="body2" color="white" sx={{ paddingBottom: '16px' }}>
        {content ? content.split('\n').map((line, index) => renderContentLine(line, index)) : ''}
      </Typography>
    );
  };

  const renderContentLine = (line: string, index: number) => {
    return (
      <Box key={index} component="span" minHeight="16px">
        {line}
      </Box>
    );
  };

  return (
    <Popper
      id="note-overlay"
      open={viewModel.isOpen}
      anchorEl={viewModel.anchor}
      placement="bottom-end"
      modifiers={[
        {
          fn: (popper) => {
            const y = popper.state.rects.reference.y;
            if (y >= window.innerHeight - 150 || y <= 150) {
              viewModel.close();
            }
          },
          phase: 'main',
          enabled: true,
          name: 'closeOutOffView'
        }
      ]}
    >
      <ClickAwayListener onClickAway={() => viewModel.close()}>
        <RoundedPaper
          sx={{
            backgroundColor: 'primary.main',
            padding: '16px',
            width: '300px',
            minHeight: '80px',
            display: 'flex',
            border: 'none',
            ...sx
          }}
          withShadow
        >
          <Box flex="1" paddingRight="16px">
            {renderContent(viewModel.item?.note ?? undefined)}
          </Box>
        </RoundedPaper>
      </ClickAwayListener>
    </Popper>
  );
});
